import { Directive, OnInit, OnDestroy } from '@angular/core';
import { DatePicker } from 'primeng/datepicker';
import { PrimeNG } from 'primeng/config';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';

@Directive({
    selector: '[fpCalendarLocale], p-calendar, p-datepicker, p-datePicker',
    standalone: false
})
export class CalendarLocaleDirective implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  constructor(
    private calendar: DatePicker,
    private config: PrimeNG,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.translate.onLangChange.pipe(takeUntil(this.destroy$)).subscribe(event => {
      this.updateCalendar(event.lang);
    });

    this.updateCalendar(this.translate.currentLang || 'en');
  }

  private updateCalendar(lang: string) {
    const isCentralEurope = ['cz', 'cs'].includes(lang.toLowerCase());
    this.calendar.firstDayOfWeek = isCentralEurope ? 1 : 0;
    this.translate.get('primeng').subscribe(res => {
      if (res) {
        this.config.setTranslation(res);
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
